(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6634],{

/***/ 8126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mais-vendidos-melhores-precos",
      function () {
        return __webpack_require__(39404);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SearchPage": function() { return /* binding */ SearchPage; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _objectedge_pecai_storefront_ds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18265);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9911);
/* harmony import */ var _utils_storyblok__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56447);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50545);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);









var __N_SSG = true;
var SearchPage = (0,_utils_storyblok__WEBPACK_IMPORTED_MODULE_5__/* .storyblokPage */ .Q2)(function(param) {
    var story = param.story;
    var products = [
        {
            id: "8da63fa1-8640854529c-1f3-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/8da63fa1-8642-4fd8-bf19-7538fc639574/da9eddc4-aee7-4b1d-b924-7e312d060f8b.jpg",
            name: "ADITIVO PARA RADIADOR PARAFLU - 10-3001",
            pDPPath: "/produto/8da63fa1-8640854529c-1f3-12uni",
            price: "296,48",
            unitPrice: "24,71",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "4c11989b-eef0854529c-1f3-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/4c11989b-eefb-4f18-997b-bfaacfbb61ce/175f95f8-c0f9-428d-9df7-7ecc79a2ea5a.jpg",
            name: "ADITIVO PARA RADIADOR PARAFLU - 10-3004",
            pDPPath: "/produto/4c11989b-eef0854529c-1f3-12uni",
            price: "210,10",
            unitPrice: "17,51",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "9eeb9f9c-6750854529c-1f3-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/9eeb9f9c-6758-4ccf-a82e-54ac7fb995d9/e3710532-110b-44ed-9320-c4390f3cbd9c.jpg",
            name: "ADITIVO PARA RADIADOR DELPHI - RL10016",
            pDPPath: "/produto/9eeb9f9c-6750854529c-1f3-12uni",
            price: "137,45",
            unitPrice: "11,45",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "35edf31f-61d0b222bea-cf4-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/35edf31f-61d7-4757-98cc-7f91c23794aa/ac194671-2680-4f16-b1a0-9fc2457fa56e.jpg",
            name: "BATERIA 12V 60AH BOSCH - 0 092 S58 048",
            pDPPath: "/produto/35edf31f-61d0b222bea-cf4-1uni",
            price: "459,02",
            unitPrice: "459,02",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "f069df00-c3e0b222bea-cf4-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/f069df00-c3ef-4d4a-be24-0aa98feab36d/f4acab58-788a-451e-836e-692f6ebdedc6.jpg",
            name: "BATERIA 12V 50AH BOSCH - 0 092 S58 078",
            pDPPath: "/produto/f069df00-c3e0b222bea-cf4-1uni",
            price: "462,56",
            unitPrice: "462,56",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "1cd6d33b-88e0b222bea-cf4-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/1cd6d33b-88ef-42fc-b525-f5d27f29e1c2/be5eebaa-599a-4a34-b349-09468686f56c.jpg",
            name: "BATERIA 12V 45AH BOSCH - 0 092 S58 018",
            pDPPath: "/produto/1cd6d33b-88e0b222bea-cf4-1uni",
            price: "411,82",
            unitPrice: "411,82",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "7af7dc0b-d116d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/7af7dc0b-d115-4022-b1b3-b8c9a44d7d7c/2879aef1-9f04-4189-89f1-9a7083519ce9.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W30 SP SINT\xc9TICO - 1LT",
            pDPPath: "/produto/7af7dc0b-d116d7e40f2-f17-24uni",
            price: "674,60",
            unitPrice: "28,11",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "480fdafc-d9ea5f94290-722-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/480fdafc-d9e1-49e4-a7e9-662eabb29b68/1ad10f1b-267d-44ba-8766-e1e98ec5270e.jpg",
            name: "FLUIDO DE FREIO DOT4 - TIRRENO FLU/DS/211SO2",
            pDPPath: "/produto/480fdafc-d9ea5f94290-722-1uni",
            price: "23,92",
            unitPrice: "23,92",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "d49584b9-513a5f94290-722-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/d49584b9-5138-424b-82b6-921d8299bf0e/441f70e0-6cf7-477e-b820-9a4639dc9a74.jpg",
            name: "FLUIDO DE FREIO DOT 4 500ML - ATE 6092",
            pDPPath: "/produto/d49584b9-513a5f94290-722-1uni",
            price: "23,33",
            unitPrice: "23,33",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "4e9b4647-54b6d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/4e9b4647-54b9-4e3c-8574-a569480eed04/thumb-24f4784f-1645-46eb-9b6f-bfed56c98aea.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W30 SP SINT\xc9TICO - 24X1L",
            pDPPath: "/produto/4e9b4647-54b6d7e40f2-f17-24uni",
            price: "645,6",
            unitPrice: "26,90",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "bfe94a9a-93d6d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/4e9b4647-54b9-4e3c-8574-a569480eed04/thumb-24f4784f-1645-46eb-9b6f-bfed56c98aea.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W30 SP SINT\xc9TICO - 12X1L",
            pDPPath: "/produto/bfe94a9a-93d6d7e40f2-f17-12uni",
            price: "356,40",
            unitPrice: "29,70",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "7af7dc0b-d116d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/4e9b4647-54b9-4e3c-8574-a569480eed04/thumb-24f4784f-1645-46eb-9b6f-bfed56c98aea.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W30 SP SINT\xc9TICO - 1L",
            pDPPath: "7af7dc0b-d116d7e40f2-f17-1uni",
            price: "32,80",
            unitPrice: "32,80",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "fd4d8ae1-7576d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/fd4d8ae1-7570-41f2-91d2-a579263b37b7/thumb-cf371947-048b-4d22-a930-770377e96cf2.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PROTECTION 20W50 SL MINERAL 24X1L",
            pDPPath: "/produto/fd4d8ae1-7576d7e40f2-f17-24uni",
            price: "477,63",
            unitPrice: "19,90",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "1e555f84-ae46d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/fd4d8ae1-7570-41f2-91d2-a579263b37b7/thumb-cf371947-048b-4d22-a930-770377e96cf2.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PROTECTION 20W50 SL MINERAL 12X1L",
            pDPPath: "/produto/1e555f84-ae46d7e40f2-f17-12uni",
            price: "264,15",
            unitPrice: "22,00",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "ebd708b5-c806d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/fd4d8ae1-7570-41f2-91d2-a579263b37b7/thumb-cf371947-048b-4d22-a930-770377e96cf2.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PROTECTION 20W50 SL MINERAL 1L",
            pDPPath: "/produto/ebd708b5-c806d7e40f2-f17-1uni",
            price: "24,30",
            unitPrice: "24,30",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "41f9bcc9-ed26d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/41f9bcc9-ed23-484d-9770-381e9d2f9391/thumb-f017b69a-83c7-4a2e-9318-0a8868e4a274.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 15W40 SL SEMISSINT\xc9TICO 24X1L",
            pDPPath: "/produto/41f9bcc9-ed26d7e40f2-f17-24uni",
            price: "511,40",
            unitPrice: "21,30",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "a71f9dc2-7aa6d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/41f9bcc9-ed23-484d-9770-381e9d2f9391/thumb-f017b69a-83c7-4a2e-9318-0a8868e4a274.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 15W40 SL SEMISSINT\xc9TICO 12X1L",
            pDPPath: "/produto/a71f9dc2-7aa6d7e40f2-f17-12uni",
            price: "283,2",
            unitPrice: "23,60",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "14967d41-b816d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/41f9bcc9-ed23-484d-9770-381e9d2f9391/thumb-f017b69a-83c7-4a2e-9318-0a8868e4a274.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 15W40 SL SEMISSINT\xc9TICO 1L",
            pDPPath: "/produto/14967d41-b816d7e40f2-f17-1uni",
            price: "26,00",
            unitPrice: "26,00",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "7e9341e9-1736d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/7e9341e9-1735-4a16-ac15-d5d7c1570713/thumb-ff275f61-ef42-4b00-add1-146929686042.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 10W40 SM SINT\xc9TICO 24X1L",
            pDPPath: "/produto/7e9341e9-1736d7e40f2-f17-24uni",
            price: "794,4",
            unitPrice: "33,10",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "7ba94b90-0446d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/7e9341e9-1735-4a16-ac15-d5d7c1570713/thumb-ff275f61-ef42-4b00-add1-146929686042.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 10W40 SM SINT\xc9TICO 12X1L",
            pDPPath: "/produto/7ba94b90-0446d7e40f2-f17-12uni",
            price: "438",
            unitPrice: "36,50",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "fe127965-8646d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/7e9341e9-1735-4a16-ac15-d5d7c1570713/thumb-ff275f61-ef42-4b00-add1-146929686042.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 10W40 SM SINT\xc9TICO 1L",
            pDPPath: "/produto/fe127965-8646d7e40f2-f17-1uni",
            price: "40,30",
            unitPrice: "40,30",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "b0905aee-e2f6d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/17b8f4a6-d7c6-4260-a8b1-e59efee532ae/thumb-135b33a6-7f4b-4d86-9cb9-e9a9b3739932.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W40 SN SEMISSINT\xc9TICO 24x1L",
            pDPPath: "/produto/b0905aee-e2f6d7e40f2-f17-24uni",
            price: "645,6",
            unitPrice: "26,9",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "7cd6d4e8-9c76d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/17b8f4a6-d7c6-4260-a8b1-e59efee532ae/thumb-135b33a6-7f4b-4d86-9cb9-e9a9b3739932.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W40 SN SEMISSINT\xc9TICO 12x1L",
            pDPPath: "/produto/7cd6d4e8-9c76d7e40f2-f17-12uni",
            price: "356,4",
            unitPrice: "29,70",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "17b8f4a6-d7c6d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/17b8f4a6-d7c6-4260-a8b1-e59efee532ae/thumb-135b33a6-7f4b-4d86-9cb9-e9a9b3739932.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W40 SN SEMISSINT\xc9TICO 1L",
            pDPPath: "/produto/17b8f4a6-d7c6d7e40f2-f17-1uni",
            price: "32,80",
            unitPrice: "32,80",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "e85f0269-d986d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/e85f0269-d989-4a27-955e-56fba471e232/thumb-885e840a-646d-42f4-ab00-76a732f77a09.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W40 508 SINTETICO 24X1L",
            pDPPath: "/produto/e85f0269-d986d7e40f2-f17-24uni",
            price: "993,6",
            unitPrice: "41,40",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "0965ebbe-1756d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/e85f0269-d989-4a27-955e-56fba471e232/thumb-885e840a-646d-42f4-ab00-76a732f77a09.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W40 508 SINTETICO 12X1L",
            pDPPath: "/produto/0965ebbe-1756d7e40f2-f17-12uni",
            price: "548,4",
            unitPrice: "45,70",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "4cd7389d-eb56d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/e85f0269-d989-4a27-955e-56fba471e232/thumb-885e840a-646d-42f4-ab00-76a732f77a09.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER 5W40 508 SINTETICO 1L",
            pDPPath: "/produto/4cd7389d-eb56d7e40f2-f17-1uni",
            price: "50,40",
            unitPrice: "50,40",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "f7b15b80-8326d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/f7b15b80-8328-493f-867c-31ff36167322/thumb-1b6f3231-756a-4594-8d63-2f5e056f611f.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W30 SEMISSINT\xc9TICO 24X1L",
            pDPPath: "/produto/f7b15b80-8326d7e40f2-f17-24uni",
            price: "772,8",
            unitPrice: "32,20",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "00386b7c-0656d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/f7b15b80-8328-493f-867c-31ff36167322/thumb-1b6f3231-756a-4594-8d63-2f5e056f611f.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W30 SEMISSINT\xc9TICO 12X1L",
            pDPPath: "/produto/00386b7c-0656d7e40f2-f17-12uni",
            price: "426",
            unitPrice: "35,5",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "d3992a9e-b056d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/f7b15b80-8328-493f-867c-31ff36167322/thumb-1b6f3231-756a-4594-8d63-2f5e056f611f.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER PERFORMANCE 10W30 SEMISSINT\xc9TICO 1L",
            pDPPath: "/produto/d3992a9e-b056d7e40f2-f17-1uni",
            price: "39,20",
            unitPrice: "39,20",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "0240a1cb-ea86d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/0240a1cb-ea85-49f0-9841-df9098507fb1/thumb-dfeb3b45-507f-407a-a77c-c620d339e5e0.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER SINT\xc9TICO 5W40 SP - 24X1L",
            pDPPath: "/produto/0240a1cb-ea86d7e40f2-f17-24uni",
            price: "758,4",
            unitPrice: "31,60",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "d1718eaf-9156d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/0240a1cb-ea85-49f0-9841-df9098507fb1/thumb-dfeb3b45-507f-407a-a77c-c620d339e5e0.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER SINT\xc9TICO 5W40 SP - 12X1L",
            pDPPath: "/produto/d1718eaf-9156d7e40f2-f17-12uni",
            price: "422,4",
            unitPrice: "35,2",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "cb187cc7-bfe6d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/0240a1cb-ea85-49f0-9841-df9098507fb1/thumb-dfeb3b45-507f-407a-a77c-c620d339e5e0.jpg",
            name: "\xd3LEO DO MOTOR IPIRANGA - F1 MASTER SINT\xc9TICO 5W40 SP - 1L",
            pDPPath: "/produto/cb187cc7-bfe6d7e40f2-f17-1uni",
            price: "38,90",
            unitPrice: "38,90",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "785a13c7-0846d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/785a13c7-0849-4869-9408-c8cb4109c4de/thumb-a506d193-e8fb-4d9f-a9c1-610670bca8c9.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - SUPERIOR SL 20W50 MINERAL 24X1L",
            pDPPath: "/produto/785a13c7-0846d7e40f2-f17-24uni",
            price: "477,6",
            unitPrice: "19,90",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "fcfc81fc-a3d6d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/785a13c7-0849-4869-9408-c8cb4109c4de/thumb-a506d193-e8fb-4d9f-a9c1-610670bca8c9.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - SUPERIOR SL 20W50 MINERAL 12X1L",
            pDPPath: "/produto/fcfc81fc-a3d6d7e40f2-f17-12uni",
            price: "264",
            unitPrice: "22,00",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "032395b8-ddd6d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/785a13c7-0849-4869-9408-c8cb4109c4de/thumb-a506d193-e8fb-4d9f-a9c1-610670bca8c9.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - SUPERIOR SL 20W50 MINERAL 1L",
            pDPPath: "/produto/032395b8-ddd6d7e40f2-f17-1uni",
            price: "24,30",
            unitPrice: "24,30",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "a930e9fb-b876d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/a930e9fb-b87a-42e1-92b3-dbe081673ee4/thumb-87d9c31a-e25a-484e-8e27-8259af7c13f8.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - 4T 10W40 SL SEMISSINT\xc9TICO - 24X1L",
            pDPPath: "/produto/a930e9fb-b876d7e40f2-f17-24uni",
            price: "621,6",
            unitPrice: "25,90",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "18d9729a-5a06d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/a930e9fb-b87a-42e1-92b3-dbe081673ee4/thumb-87d9c31a-e25a-484e-8e27-8259af7c13f8.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - 4T 10W40 SL SEMISSINT\xc9TICO - 12X1L",
            pDPPath: "/produto/18d9729a-5a06d7e40f2-f17-12uni",
            price: "390",
            unitPrice: "32,50",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "a9c44c47-d026d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/a930e9fb-b87a-42e1-92b3-dbe081673ee4/thumb-87d9c31a-e25a-484e-8e27-8259af7c13f8.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - 4T 10W40 SL SEMISSINT\xc9TICO - 1L",
            pDPPath: "/produto/a9c44c47-d026d7e40f2-f17-1uni",
            price: "35,90",
            unitPrice: "35,90",
            description: [],
            qmvDescription: undefined
        },
        {
            id: "602699c4-17e6d7e40f2-f17-24uni",
            image: "https://fragaimages.blob.core.windows.net/product/602699c4-17e0-4147-a93e-810b41824357/thumb-450132bd-702f-42d7-93ae-989527650b24.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - PRO DS FULL SYNTHETIC 0W20 SN/RC 24X1L",
            pDPPath: "/produto/602699c4-17e6d7e40f2-f17-24uni",
            price: "825,6",
            unitPrice: "34,40",
            description: [],
            qmvDescription: "(24 UNID)"
        },
        {
            id: "6d741280-b3b6d7e40f2-f17-12uni",
            image: "https://fragaimages.blob.core.windows.net/product/602699c4-17e0-4147-a93e-810b41824357/thumb-450132bd-702f-42d7-93ae-989527650b24.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - PRO DS FULL SYNTHETIC 0W20 SN/RC 12X1L",
            pDPPath: "/produto/6d741280-b3b6d7e40f2-f17-12uni",
            price: "454,8",
            unitPrice: "37,90",
            description: [],
            qmvDescription: "(12 UNID)"
        },
        {
            id: "93d7ad3d-7e96d7e40f2-f17-1uni",
            image: "https://fragaimages.blob.core.windows.net/product/602699c4-17e0-4147-a93e-810b41824357/thumb-450132bd-702f-42d7-93ae-989527650b24.jpg",
            name: "\xd3LEO DO MOTOR HAVOLINE - PRO DS FULL SYNTHETIC 0W20 SN/RC 1L",
            pDPPath: "/produto/93d7ad3d-7e96d7e40f2-f17-1uni",
            price: "41,80",
            unitPrice: "41,80",
            description: [],
            qmvDescription: undefined
        }, 
    ];
    var breadCrumbs = [
        {
            key: 1,
            href: "/",
            name: "Home"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts__WEBPACK_IMPORTED_MODULE_4__/* .StoryLayout */ .yp, {
        unsecure: false,
        story: story,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Pe\xe7a a\xed - O maior estoque de pe\xe7as para a sua oficina"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_objectedge_pecai_storefront_ds__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W20, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "mb-2 mt-4",
                        children: "Mais vendidos"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_objectedge_pecai_storefront_ds__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumb */ .aGc, {
                        activeName: "Mais vendidos",
                        crumbs: breadCrumbs,
                        listClassName: "pl-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
                            children: products.map(function(product) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/produto/".concat(product.id),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-decoration-none",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_objectedge_pecai_storefront_ds__WEBPACK_IMPORTED_MODULE_3__/* .ProductCard */ .Ilp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, product), {
                                            dense: true
                                        }))
                                    })
                                }, product.id);
                            })
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["default"] = (SearchPage);


/***/ }),

/***/ 50545:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mais-vendidos-melhores-precos_wrapper__6QpZ7"};

/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [486,7249,9911,9774,2888,179], function() { return __webpack_exec__(8126); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);